import { LazyLoader } from "@NextSkyTheme/lazy-load";

class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();
  }
  init() {
    this.connectedCallback();
  }
  initData() {
    const savedProductsArr = JSON.parse(
      localStorage.getItem("recently-viewed-products")
    );
    this.getStoredProducts(savedProductsArr);
  }
  getStoredProducts(arr) {
    const limit = Number(this.dataset?.limit) || 4;

    if (!Array.isArray(arr) || arr.length === 0) {
      return;
    }

    const idsToUse = arr
      .map(String)
      .filter((id) => /^\d+$/.test(id))
      .slice(0, limit);

    if (!idsToUse.length) {
      return;
    }

    const url = new URL(this.dataset.url, window.location.origin);

    url.searchParams.set("type", "product");
    url.searchParams.set(
      "q",
      idsToUse.map((id) => `id:${id}`).join(" OR ")
    );

    fetch(url.toString())
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;

        const recentlyViewedProducts = html.querySelector(
          "recently-viewed-products"
        );

        if (
          recentlyViewedProducts &&
          recentlyViewedProducts.innerHTML.trim().length
        ) {
          this.innerHTML = recentlyViewedProducts.innerHTML;
        }

        new LazyLoader(".image-lazy-load");
      })
      .catch((e) => {
        console.error(e);
      });
  }
  connectedCallback() {
    const _this = this;
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      _this.initData();
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 100px 0px",
    }).observe(this);
  }
}
customElements.define("recently-viewed-products", RecentlyViewedProducts);